import React from 'react'
import { Outlet } from 'react-router-dom'
import { Icon, IconLibrary, NavBar, useAppLinksNavSection } from '../../../components'
import '../index.css'

export const App = ({ appName }) => {

  // Länkar live in the sidebar rather than as a right rail on Hem — null while
  // loading, and for a non-admin with no links, in which case no section renders.
  const lankar = useAppLinksNavSection(appName)

  const links = [
    // Hem is the candidate list itself, so there is no separate "Lista" entry — it would
    // be a second link to the same page.
    {
      type: "link",
      relativePath: "",
      label: "Hem",
      icon: <Icon name="home" />,
    },
    {
      type: "section",
      label: "Vyer",
      links: [
        {
          type: "link",
          relativePath: "board",
          label: "Tavla",
          icon: <IconLibrary name="grid" />,
        },
        {
          type: "link",
          relativePath: "interviews",
          label: "Intervjuer",
          icon: <IconLibrary name="calendar" />,
        },
      ],
    },
    ...(lankar ? [lankar] : []),
  ]

  return (
    <div className={"app-container" + (appName ? " " + appName : "")}>

      <NavBar links={links} appName={appName} />

      <div className="app-content">
        <Outlet context={appName} />
      </div>

    </div>
  )
}
